module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/header_background-3a304de1f1458212b70b53e1af935185.png";